<<!-- upfile -->
<template>
  <div>
    <el-dialog
      :visible.sync="show"
      width="480px"
      :close-on-click-modal="false"
      :before-close="handleClose"
      title="上传结算信息"
    >
      <el-form :model="form" ref="form" label-width="140px">
        <el-form-item label="结算方式：">
          <span>{{set_list.settlement_type==1?'按付款金额结算':'按订单量结算'}}</span>
        </el-form-item>
        <el-form-item label="订单量：" :required="true">
          <div class="flex-al">
            <el-input
              v-model.trim="form.order_num"
              type="number"
              class="w-220"
              @mousewheel.native.prevent
              @change="getChange"
            ></el-input>
            <el-popover ref="shuliang" placement="top-start" trigger="hover">
              <div class="fz-14">请上传合作期间内销售总件数</div>
            </el-popover>
            <i class="el-icon-question tips c-f04" v-popover:shuliang></i>
          </div>
        </el-form-item>
        <el-form-item label="付款金额：" :required="true">
          <div class="flex-al">
            <el-input
              v-model.trim="form.order_money"
              type="number"
              class="w-196"
              @mousewheel.native.prevent
              @change="getChange"
            ></el-input>
            <span class="ml-10">元</span>
            <el-popover ref="zonge" placement="top-start" trigger="hover">
              <div class="fz-14">请上传合作期间内付款总额</div>
            </el-popover>
            <i class="el-icon-question tips c-f04" v-popover:zonge></i>
          </div>
        </el-form-item>
        <el-form-item label="服务费总额：" :required="true">
          <div class="flex-al">
            <div class="w-220">{{form.real_payment}}元</div>
            <el-popover ref="yuan" placement="top-start" trigger="hover">
              <div class="fz-14">按不同结算方式自动计费</div>
            </el-popover>
            <i class="el-icon-question tips c-f04" v-popover:yuan></i>
          </div>
        </el-form-item>
        <el-form-item label="优惠券使用截图：" :required="true">
          <div class="flex-al">
            <span class="w-220  c-9da" >
              <span @click="showExample" class='pointer'>查看示例</span></span>
            <el-popover ref="popover1" placement="top-start" title width="200" trigger="hover">
              <div class="fz-14">【天猫】请登录千牛>营销工作台>优惠券>查看数据，上传本次活动数据截图;</div>
              <div class="fz-14">【京东】请登录商智>营销>工具效果>优惠券促销详情，上传本次活动的数据截图。</div>
            </el-popover>
            <i class="el-icon-question tips c-f04" v-popover:popover1></i>
          </div>
        </el-form-item>
        <el-form-item label>
          <Upsome :file_list="file_list" :type="1" :limits="limits" @getPic="getPic"></Upsome>
        </el-form-item>
      </el-form>
      <el-dialog
        width="640px"
        title
        :visible.sync="innerVisible"
        append-to-body
        :close-on-click-modal="false"
      >
        <el-carousel height="540px">
          <el-carousel-item v-for="item in example" :key="item" :autoplay="false">
            <img :src="item" style="width:100%;">
          </el-carousel-item>
        </el-carousel>
      </el-dialog>
      <span slot="footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="orderStatus">确认提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import "./tool.css";
import Upsome from "../template/upsome.vue";
export default {
  name: "upfile",
  data() {
    return {
      api: {
        orderStatus: "home/Merchant/saveSettlementInfo"
      },
      show: true,
      innerVisible: false,
      form: {
        order_num: "", //订单数量
        order_money: "", //付款金额
        real_payment: "", //服务费总额
        settlement_pic: "" //图片链接
      },
      file_list: [],
      example: [
        "https://img1.linkstars.com/201911/08/5dc5330a487417382.jpg",
        "https://qnimg1.linkstars.com/201911/08/5dc533442687c5445.jpg"
      ],
      limits: 5
    };
  },
  components: {
    Upsome: Upsome
  },
  props: ["set_list"],
  created() {
    console.log(this.set_list);
    if (this.set_list.order_num!='') {
      this.setDefault();
    }
  },
  mounted() {},
  methods: {
    setDefault() {
      //审核不通过参数值默认带出
      this.form.order_num = Number(this.set_list.order_num);
      this.form.order_money = Number(this.set_list.order_money);
      this.form.real_payment = Number(this.set_list.real_payment);
      this.form.settlement_pic = this.set_list.settlement_pic;
      let list = this.set_list.settlement_pic.split(",");
      for (let i = 0; i < list.length; i++) {
        let json = {
          url: list[i]
        };
        this.file_list.push(json);
      }
    },
    handleClose() {
      //关闭前
      this.$emit("getUp", 1);
    },
    showExample() {
      this.innerVisible = true;
    },
    getPic(data) {
      //获得上传的所有图片
      console.log(data);
      this.form.settlement_pic = data;
    },
    orderStatus() {
      //保存上传的凭证
      let _this = this;
      let num = this.getRule();
      if (num > 0) {
        return false;
      }
      this.$http({
        method: "POST",
        url: _this.api.orderStatus,
        data: {
          mtstorid: _this.set_list.mtstorid,
          order_money: _this.form.order_money,
          order_num: _this.form.order_num,
          real_payment: _this.form.real_payment,
          settlement_pic: _this.form.settlement_pic,
          need_payment: _this.form.real_payment
        }
      }).then(res => {
        if (res.code == 1) {
          this.$emit("getUp", 2);
          this.$message.success(res.msg);
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    getChange() {
      //计算
      if (this.set_list.settlement_type == 1) {
        this.form.real_payment = (
          Number(this.form.order_money) * Number(this.set_list.settlement_rate/100)
        ).toFixed(2);
      } else if (this.set_list.settlement_type == 2) {
        this.form.real_payment = (
          Number(this.form.order_num) * Number(this.set_list.settlement_free)
        ).toFixed(2);
      }
    },
    getRule() {
      //进行验证
      let num = 0;
      if (this.form.order_num=='') {
        this.$message.warning("请填写订单量");
        num++;
      } else if (!(/(^[0-9]\d*$)/.test(this.form.order_num))) {
        this.$message.warning("订单量请填写大于等于0的正整数");
        num++;
      } else if (this.form.order_money=='') {
        this.$message.warning("请填写应付金额");
        num++;
      } else if (!(/^(\d+|\d+\.\d{1,2})$/.test(this.form.order_money))) {
        this.$message.warning("应付金额请填写大于等于0的应付金额且小数点后最多保留两位");
        num++;
      } else if (!this.form.settlement_pic) {
        this.$message.warning("请上传结算凭证截图");
        num++;
      }
      return num;
    }
  }
};
</script>
<style  scoped>
.w-220 {
  width: 220px;
}
.w-196 {
  width: 196px;
}
.tips {
  font-size: 20px;
  margin-left: 10px;
}
.c-f04 {
  color: #ff0044;
}
.example_img {
  width:600px;
  height:500px;
}
.b-000 {
  background: #000;
}
</style>